import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/trading/selling-positions.md?raw';

const TradingSellingPositions: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default TradingSellingPositions;
